import React from 'react';
import { LayoutChangeEvent } from 'react-native';

interface UseStepOneCustomerResultsMenuProps {
  hasSelectedCustomer: boolean;
  customerSearchResultItemsLength: number;
  showNotFoundMessage: boolean;
  canShowSearchResults: boolean;
}

interface UseStepOneCustomerResultsMenuResult {
  isCustomerResultsMenuOpen: boolean;
  customerSearchInputWidth: number;
  closeMenu: () => void;
  handleCustomerSearchContainerLayout: (event: LayoutChangeEvent) => void;
}

export const useStepOneCustomerResultsMenu = ({
  hasSelectedCustomer,
  customerSearchResultItemsLength,
  showNotFoundMessage,
  canShowSearchResults,
}: UseStepOneCustomerResultsMenuProps): UseStepOneCustomerResultsMenuResult => {
  const [isCustomerResultsMenuOpen, setIsCustomerResultsMenuOpen] = React.useState(false);
  const [customerSearchInputWidth, setCustomerSearchInputWidth] = React.useState(0);

  React.useEffect(() => {
    if (!canShowSearchResults) {
      setIsCustomerResultsMenuOpen(false);
      return;
    }

    const shouldOpen =
      (!hasSelectedCustomer && customerSearchResultItemsLength > 0) || showNotFoundMessage;

    setIsCustomerResultsMenuOpen(shouldOpen);
  }, [
    canShowSearchResults,
    customerSearchResultItemsLength,
    hasSelectedCustomer,
    showNotFoundMessage,
  ]);

  const closeMenu = React.useCallback(() => {
    setIsCustomerResultsMenuOpen(false);
  }, []);

  const handleCustomerSearchContainerLayout = React.useCallback(
    (event: LayoutChangeEvent) => {
      const { width } = event.nativeEvent.layout;
      if (width !== customerSearchInputWidth) {
        setCustomerSearchInputWidth(width);
      }
    },
    [customerSearchInputWidth]
  );

  return {
    isCustomerResultsMenuOpen,
    customerSearchInputWidth,
    closeMenu,
    handleCustomerSearchContainerLayout,
  };
};
